"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lodash_1 = require("lodash");
class HttpAdapter {
    constructor(config) {
        this.get = async (url, headers) => {
            const { status, data } = await this.axios.get(url, headers);
            return { status, data };
        };
        this.post = async (url, data, headers) => {
            const { status, data: _data } = await this.axios.post(url, data, headers);
            return { status, data: _data };
        };
        this.axios = axios_1.default.create({
            ...(0, lodash_1.omit)(config, ["config"]),
            baseURL: config?.baseUrl
        });
        if (config) {
            this.setConfig(config);
        }
    }
    setConfig(config) {
        if (!config)
            throw new Error("config object undefined");
        this.axios = axios_1.default.create({ ...config, baseURL: config.baseUrl });
    }
}
exports.default = HttpAdapter;
//# sourceMappingURL=HttpAdapter.js.map